import React from 'react'
import TagList from './TagList'
import {tagCloudSelector} from '../selectors'

/** @param {import('./TagCloud').TagCloudProps} props */
export default function TagCloud(props) {
    const tags = tagCloudSelector({
        tags: props.tags,
        filters: props.filters,
    })

    return (
        Boolean(tags.length) && (
            <TagList
                containerClassName="tag-cloud"
                itemClassName="tag-cloud__item"
                tags={tags}
                tagClick={() => {}}
            />
        )
    )
}
